import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import {
  MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_AGENT,
  MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_SUNROOM,
  MARKETING_PARTNER_LISTING_SUNROOM_COMMISSION,
} from 'common/marketingPartnerListingConstants';

import { formatPercentage } from 'common/formatters';

import SrSelectionCard from 'client/components/SrSelectionCard/SrSelectionCard';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrBox from 'client/components/SrBox';

const SrLeaseAgreement = ({ formikBag, onForceNext, onNext, partner }) => {
  const isAgent =
    formikBag.values.listingAgreementSignedBy ===
    MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_AGENT;
  const _onClickAgent = () => {
    if (isAgent) {
      onNext();
    } else {
      formikBag.setFieldValue(
        'listingAgreementSignedBy',
        MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_AGENT,
      );
      onForceNext();
    }
  };

  const isSunroom =
    formikBag.values.listingAgreementSignedBy ===
    MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_SUNROOM;
  const _onClickSunroom = () => {
    if (isSunroom) {
      onNext();
    } else {
      formikBag.setFieldValue(
        'listingAgreementSignedBy',
        MARKETING_PARTNER_LISTING_AGREEMENT_SIGNED_BY_SUNROOM,
      );
      onForceNext();
    }
  };

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const leaseFeePercentage = partner?.billingFees?.leaseFeePercentage;

  const partnerCommissionPercentage =
    typeof leaseFeePercentage === 'number' ? leaseFeePercentage : 1;

  return (
    <SrGridRow columns={2}>
      <SrBox marginTop={isSmallScreen ? '2px' : '23px'}>
        <SrSelectionCard
          bannerText="Most Popular"
          title="I want to stay involved."
          price={formatPercentage(partnerCommissionPercentage)}
          priceHeadline="Our Price:"
          priceText="First month's rent"
          priceDescription="Paid by you, after the renter moves in."
          listHeadline="You work directly with your client."
          listItems={[
            'You send updates',
            'You set the rent price',
            'You get the listing agreement signed',
            'You leave a key at the property',
            'You receive payment from your client & send Sunroom our cut',
          ]}
          buttonText="Get Started"
          onClick={_onClickAgent}
        />
      </SrBox>
      <SrBox marginTop={isSmallScreen ? '15px' : '23px'}>
        <SrSelectionCard
          title="Take me out of the process."
          price={`${formatPercentage(MARKETING_PARTNER_LISTING_SUNROOM_COMMISSION)}`}
          priceHeadline="Our Price:"
          priceText="First month's rent"
          priceDescription="Paid by your client, after the renter moves in."
          listHeadline="Sunroom works directly with your client."
          listItems={[
            'Sunroom sends updates',
            'Sunroom gets the listing agreement signed',
            'Sunroom leaves a key at the property',
            'Sunroom bills your client & pays you your cut',
            'Sunroom handles the entire operational process',
          ]}
          buttonText="Get Started"
          onClick={_onClickSunroom}
        />
      </SrBox>
    </SrGridRow>
  );
};

SrLeaseAgreement.propTypes = {
  formikBag: PropTypes.object.isRequired,
  onForceNext: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

SrLeaseAgreement.displayName = 'SrLeaseAgreement';

export default SrLeaseAgreement;
